import { forwardRef, useEffect, useImperativeHandle } from 'react';

import { useForm } from 'react-hook-form';
import { CustomFields } from 'views/Company/tabs/CustomFields/components/CustomFields/CustomFields';

export const CandidateCustomFields = forwardRef(
  ({ candidate, customFields, onUpdate = () => {} }, ref) => {
    const { register, watch, reset, control, handleSubmit } = useForm({ defaultValues: candidate });

    useImperativeHandle(
      ref,
      () => ({
        submit: () => handleSubmit(onUpdate)(),
      }),
      [handleSubmit, onUpdate],
    );

    useEffect(() => reset(candidate), [candidate]);

    return (
      <form onSubmit={handleSubmit(onUpdate)} className="background-secondary u-padding">
        <div className="card card-with-border u-padding">
          <CustomFields fields={customFields} watch={watch} register={register} control={control} />
        </div>
      </form>
    );
  },
);
CandidateCustomFields.displayName = 'CandidateCustomFields';
